import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import { trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import poll from '../../lib/poll';
import { nodeChatOnPageValidator } from '../../lib/node-chat-on-page-validator';
import { loadChatIneligibleModalContainer } from '../../contactUs/actions/action-chat-ineligible-modal';
import { loadMessageModal } from '../../contactUs/actions/action-login-modal';
import { chatBotClickedFalseAction } from '../../contactUs/actions/action-chat-bot';
import fireImpressionFptiForChatLoadError from '../../lib/fire-impression-fpti-for-chat-load-error';
import AsyncHelper from '../../lib/asyncMessageHelper';
import { unreadConversationChecker } from '../../lib/conversationMsgHelper';
import l10n from '../../lib/reactPPl10nHelper';

const modalErrorMsg = l10n.getContent('smarthelp/info.info.title.functionIsUnavailable');

// the Poll function will retry for at least 3.20 secs based on current retries = 5 and delay = 200 ms
const pollRetries = 5;
const pollDelay = 200;
const chatBotPostServiceEnabled = Page.isChatBotPostServiceEnabled();


function setChatBotLoaded() {
  return { type: types.SET_CHAT_BOT_LOADED };
}

function setChatBotError() {
  return { type: types.SET_CHAT_BOT_ERROR };
}

function chatBotLoaded() {
  return (dispatch) => {
    // Trigger Async Chat for the Async Pilot users
    if (Page.isPilotUser()) {
      return AsyncHelper.rediretPromise(unreadConversationChecker, { topicRefId: 'c2cip|homePage' });
    }

    // Waits at least 3.20 secs based on current retries = 5 and delay = 200 ms
    return poll(nodeChatOnPageValidator, pollRetries, pollDelay)
      .then(() => {
        trackPage({ id: 'chatBot' });
        dispatch(setChatBotLoaded());
        // eslint-disable-next-line no-undef
        nodeChat.show('chatBot', 'c2cip|homePage');
      });
  };
}

function chatBotEligibleCheck() {
  return (dispatch) => {
    axios.get('/smarthelp/chat-bot-eligibility')
      // eslint-disable-next-line
        .then((response) => {
          if (response && response.data && response.data.chatBotInfo && response.data.chatBotInfo.chatEnabled) {
            dispatch(chatBotLoaded());
          }
        })
        .catch(() => {
          dispatch(setChatBotError());
          fireImpressionFptiForChatLoadError();
        });
  };
}


// displaying chatBot in the HCR article/FAQ page
function displayChatBot() {
  return (dispatch, getState) => {
    const articleChatBotClicked = (typeof sessionStorage === 'object') && sessionStorage.getItem('articlePagechatBotClicked') === 'true';
    const isChatBotEnabled = Page.getIsChatBotEnabled();
    const isArticleChatBotEligible = Page.getIsArticleChatBotEligible();
    const isLoggedIn = Page.isLoggedIn();

    // postchatBotEligibity API response check for Chatbot Eligibility
    const chatBotEligiblityCheck = _get(getState(), 'postChatBotEligibility.chatBotDisplay');

    if (!isLoggedIn) {
      return null;
    }

    /**
     * if Chatbot is not enabled for this article triggering chat ineligible modal
     */
    const loadChatIneligibleModal = chatBotPostServiceEnabled ? !chatBotEligiblityCheck : !isChatBotEnabled;

    if (articleChatBotClicked) {
      // removing articleChatBotClicked from sessionStorage to avoid error message reopening
      sessionStorage.setItem('chatBotClicked', 'false');
      sessionStorage.setItem('articlePagechatBotClicked', 'false');
      // Show error message for Lexa service failed
      if (Page.isLexaPilotFailure()) {
        trackPage({ id: 'articleLexaFailureError', link: 'smarthelp-intermediate|lexa-failure' });
        return dispatch(loadMessageModal({ message: modalErrorMsg }));
      }

      // checking if the article is eligible for chatBot
      if (isArticleChatBotEligible || chatBotEligiblityCheck) {
        dispatch(chatBotClickedFalseAction()); // making chatClicked false

        // Trigger Async Chat for the Async Pilot users
        if (Page.isPilotUser()) {
          return AsyncHelper.rediretPromise(unreadConversationChecker, { topicRefId: 'GENPOOL|articlePage' });
        }

        // Waits at least 3.20 secs based on current retries = 5 and delay = 200 ms
        return poll(nodeChatOnPageValidator, pollRetries, pollDelay)
          .then(() => {
            // eslint-disable-next-line no-undef
            nodeChat.show('chatBot', 'GENPOOL|articlePage');
          })
          .catch(() => fireImpressionFptiForChatLoadError());
      } else if (loadChatIneligibleModal) {
        /**
         * if articleChatBotClicked is true and chatbot is not enabled based on pxp gops_smarthelp_chatbot_treatment
         * showing chat ineligible modal
         */
        dispatch(loadChatIneligibleModalContainer());
      }

      dispatch(chatBotClickedFalseAction());
    }
    return { type: types.CHATBOT_FAQ_DISPLAY_CHECKER };
  };
}

module.exports = {
  chatBotEligibleCheck,
  displayChatBot,
  chatBotLoaded,
};
